<template>
  <div>
    <ts-dialog title="Edit a folder" :visible.sync="visible" width="500px" center>
      <div>
        <ts-form-item label="Folder name" :validation="$v.form.name">
          <ts-input placeholder="Enter a name" v-model.lazy="$v.form.name.$model"></ts-input>
        </ts-form-item>
      </div>
      <div slot="footer" class="flex items-center justify-center">
        <div class="font-semibold">
          <ts-button class="font-semibold" :loading="loading" @click="handleSaveClick">Save changes</ts-button>
        </div>
      </div>
    </ts-dialog>
    <ts-button :loading="loading" title="Share" size="small" circle filled @click="handleOpenDialogButtonClick">
      <ts-icon icon="pen" size="x-small" title="Edit" color="#6d7587" />
    </ts-button>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

export default {
  props: {
    folder: { type: Object, required: true }
  },
  data() {
    return {
      visible: false,
      loading: false,
      form: {
        name: null
      }
    };
  },
  mounted() {
    // if (this.value.shouldOpen) {
    //   this.$refs['shareButton'].$el.querySelector('button').click();
    //   this.$store.commit('workflow/fileRequests/setFileRequest', {
    //     ...this.value,
    //     shouldOpen: false
    //   });
    // }
  },
  validations: {
    form: {
      name: {
        required
      }
    }
  },
  methods: {
    ...mapActions('workflow', ['updateFolder']),
    copy() {
      this.$emit('copy');
    },
    handleOpenDialogButtonClick() {
      this.visible = true;
      this.resetForm();
    },
    resetForm() {
      this.form = {
        name: this.folder.name
      };

      this.$v.$reset();
    },
    skip() {
      this.visible = false;
      this.resetForm();
    },
    async handleSaveClick() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loading = true;
        await this.updateFolder({ ...this.form, id: this.folder.id });
        this.loading = false;
        this.visible = false;
        this.resetForm();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.mr-4 {
  margin-right: 1rem;
}
.row {
  background: #ebecf0;
  background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
  background-blend-mode: soft-light, normal;
  background-clip: padding-box;
  border: 2px solid rgba(255, 255, 255, 0.16);
  box-shadow: -2px -2px 6px 0 rgba(250, 251, 255, 0.48), 2px 2px 6px 0 rgba(166, 171, 189, 0.24);
  border-radius: 16px;
  margin-bottom: 10px;

  display: flex;
  align-items: center;
  padding: 22px 18px;

  .checkbox {
    margin-right: 13px;
  }

  .file-info {
    width: 400px;
  }

  .file-name {
    font-family: Roboto;
    font-size: 16px;
    color: #6d7587;
  }

  .file-creation-info {
    font-family: Roboto;
    font-size: 10px;
    line-height: 16px;
    color: #acbacc;
  }

  .files {
    flex-grow: 1;
  }

  .actions {
    display: flex;
    align-items: center;

    > * {
      margin-left: 10px;
    }
  }
}
.flex {
  display: flex;
}
.justify-center {
  justify-content: center;
}
.items-center {
  align-items: center;
}
.mb-2 {
  margin-bottom: 0.5em;
}
.flex-1 {
  flex: auto;
}
.flex-none {
  flex: none;
}
.px-2 {
  padding-left: 0.5em;
  padding-right: 0.5em;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.py-2 {
  padding-top: 0.5em;
  padding-bottom: 0.5em;
}
.justify-between {
  justify-content: space-between;
}
.cursor-pointer {
  cursor: pointer;
}
</style>